import React from 'react';
import {
  Button,
  COLORS,
  Card,
  Text,
  Title,
  FlexCol,
} from 'components';
import {
  Row,
  Col,
} from 'antd';
import LinkWithTooltip from 'components/LinkWithTooltip';
import {
  EditOutlined,
  RightOutlined,
} from '@ant-design/icons';
import { REPUVE } from 'utils/env';

const Appointments = () => (
  <Row gutter={[10, 20]} justify="center" style={{ padding: 20 }}>
    <Col span={24}>
      <Title level={2}>
        Citas
      </Title>
    </Col>
    <Col xs={24} sm={24} md={12}>
      <Card bg={COLORS.white}>
        <FlexCol alignItems="start">
          <Title level={4}>
            Registro de cita
          </Title>
          <Text>
            En este apartado podrá registrar las citas de los trámites enlistados
          </Text>
          <Button $accent style={{ marginLeft: 'auto' }}>
            <LinkWithTooltip
              to="/citas/nueva"
              text="Registrar"
              title="Requiere inicio de sesión"
              icon={EditOutlined}
              redirectToLogin
            />
          </Button>
        </FlexCol>
      </Card>
    </Col>
    <Col xs={24} sm={24} md={12}>
      <Card bg={COLORS.white}>
        <FlexCol alignItems="start">
          <Title level={4}>
            Consultar o cancelar citas
          </Title>
          <Text>
            Para consultar sus citas o realizar una cancelación ingrese a su perfil
          </Text>
          <Button style={{ marginLeft: 'auto' }} $accent>
            <LinkWithTooltip
              to="/mi-cuenta/mis-citas"
              text="Mis citas"
              icon={RightOutlined}
              redirectToLogin
            />
          </Button>
        </FlexCol>
      </Card>
    </Col>
    {REPUVE && (
    <Col span={24}>
      <Card bg={COLORS.white} style={{ height: 430, padding: 8 }}>
        <Col style={{ height: 55 }}>
          <Text>
            En el siguiente video te mostraremos los pasos a seguir para registrar
            y realizar tu cita
          </Text>
        </Col>
        <iframe
          width="100%"
          height={360}
          style={{ borderRadius: 10 }}
          src="https://www.youtube.com/embed/k90kixQy4PE?si=175My8FvgDm2TyXN"
          title="Tutorial agendar cita"
          allow="fullscreen; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
        />
      </Card>
    </Col>
    )}
  </Row>
);

export default Appointments;
